import Layout from "./Layout";
import IndexPage from "./IndexPage";
import ShowPage from "./ShowPage";
import ProfileDefinitionsPage from "./ProfileDefinitions/IndexPage";
import NewProfileDefinitionPage from "./ProfileDefinitions/NewPage";
import EditProfileDefinitionPage from "./ProfileDefinitions/EditPage";
import ToolboxToolsPage from "./ToolsPage";
import CheckinDefinitionsPage from "./CheckinDefinitions/IndexPage";
import NewCheckinDefinitionPage from "./CheckinDefinitions/NewPage";
import EditCheckinDefinitionPage from "./CheckinDefinitions/EditPage";

const Index = IndexPage;

const Show = ShowPage;

const Tools = ToolboxToolsPage;

const ProfileDefinitions = ProfileDefinitionsPage;

const ProfileDefinitionsNew = NewProfileDefinitionPage;

const ProfileDefinitionsEdit = EditProfileDefinitionPage;

const CheckinDefinitions = CheckinDefinitionsPage;

const CheckinDefinitionsNew = NewCheckinDefinitionPage;

const CheckinDefinitionsEdit = EditCheckinDefinitionPage;

export const Toolboxes = {
  Layout,
  Index,
  Show,
  Tools,
  ProfileDefinitions,
  ProfileDefinitionsNew,
  ProfileDefinitionsEdit,
  CheckinDefinitions,
  CheckinDefinitionsNew,
  CheckinDefinitionsEdit,
};
